<div *ngIf="visibility" class="cand-modal ddi-faq">
    <article *ngIf="visibility" [@slideInOut] class="cand-modal__overlay">
        <header>
            <h1 class="cand-modal__title cand-modal__title--faq">
                <span>{{ 'differeddecisionintroduction.faq.title' | i18n }} </span>
                <span class="cand-modal__small-text">
                    {{ 'differeddecisionintroduction.faq.subtitle' | i18n }}
                </span>
            </h1>
        </header>
        <section class="cand-modal__content">
            <div class="ddi-faq__questions-container">
                <div *ngFor="let itemFaq of listFaqs" [ngClass]="{ active: questionIsOpen(itemFaq.id), default: !questionIsOpen(itemFaq.id) }" class="pegase-accordion ddi-faq__questions-container__question">
                    <div class="pegase-accordion__header" (click)="selectItem(itemFaq.id)">
                        <span>{{ itemFaq.question }}</span>
                        <span class="pegase-accordion__header--icon" [ngClass]="{ active: questionIsOpen(itemFaq.id), default: !questionIsOpen(itemFaq.id) }">
                            <img *ngIf="!questionIsOpen(itemFaq.id)" alt="" [appAssetSrc]="'assets/images/chevron-green-down.svg'" />
                        </span>
                    </div>
                    <div *ngIf="selectedItem === itemFaq.id">
                        <div class="ddi-faq__questions-container__question__answer" [innerHTML]="itemFaq.answer"></div>
                    </div>
                </div>
            </div>
        </section>
        <footer class="recovery-form__footer">
            <button class="button button--primary cand-modal__buttonsize" type="button" (click)="closeFaqModal()">
                {{ 'global.close' | i18n }}
            </button>
        </footer>
    </article>
    <div *ngIf="visibility" [@fadeInOut] class="cand-modal__fade" (click)="closeFaqModal()"></div>
</div>
